// File acceptance and pluralization live in the SpAdmin shared utils; re-export
// them so the app's existing import surface (and specs) stay unchanged.
export { isAcceptedFile } from "#ce/apps/SpAdmin/shared/utils/file-acceptance";
export { pluralize } from "#ce/apps/SpAdmin/shared/utils/pluralize";

export const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const NAMED_EMAIL_REGEX = /^\s*"?([^"<]+?)"?\s*<([^>]+)>\s*$/;
export const DELIMITERS = [",", ";", "|", "\n", "\r"];

export function parseToken(raw) {
  const text = raw.trim();

  if (!text) {
    return null;
  }

  const namedMatch = text.match(NAMED_EMAIL_REGEX);

  if (namedMatch) {
    const email = namedMatch[2].trim();

    if (!EMAIL_REGEX.test(email)) {
      return null;
    }

    const name = namedMatch[1].trim();
    return { email: email.toLowerCase(), label: `${name} <${email}>`, raw: text };
  }

  if (EMAIL_REGEX.test(text)) {
    return { email: text.toLowerCase(), label: text, raw: text };
  }

  return null;
}

export function tokenize(text) {
  const results = [];
  let current = "";
  let inQuotes = false;
  let inAngle = false;

  for (const ch of text) {
    if (ch === '"') {
      inQuotes = !inQuotes;
      current += ch;
    } else if (ch === "<" && !inQuotes) {
      inAngle = true;
      current += ch;
    } else if (ch === ">" && !inQuotes) {
      inAngle = false;
      current += ch;
    } else if (DELIMITERS.includes(ch) && !inQuotes && !inAngle) {
      if (current.trim()) {
        results.push(current.trim());
      }
      current = "";
    } else {
      current += ch;
    }
  }

  if (current.trim()) {
    results.push(current.trim());
  }

  const tokens = [];
  for (const token of results) {
    if (NAMED_EMAIL_REGEX.test(token)) {
      tokens.push(token);
    } else {
      for (const part of token.split(/\s+/)) {
        if (part.trim()) {
          tokens.push(part.trim());
        }
      }
    }
  }

  return tokens;
}
